module.exports = require("vue-monaco");